import { useFadeInScroll } from "../../components/Animation/fadeinScroll";
const InnovationNarration = () => {
   const title = useFadeInScroll<HTMLDivElement>();
  return (
    <section className="sm:px-12 bg-white text-center">
        <div
            ref={title.ref}
            className={`
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"}
            `}
          >
      <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-10 max-w-3xl mx-auto leading-relaxed">
        With Sacrum, you’re not just healing — you’re stepping into the future
        of orthopedic care.
      </h2>
</div>
      <ul className="max-w-3xl mx-auto space-y-4 text-left text-text-secondary leading-relaxed">
        <li>• Next-generation orthopedic solutions powered by clinical expertise</li>
        <li>• Bespoke-engineered 3D-printed Finger Splint</li>
        <li>• Glove-like anatomical fit</li>
        <li>• Lightweight design focused on faster recovery</li>
        <li>• Built for confidence, comfort, and daily use</li>
        <li>• Smart wearable proposed development</li>
      </ul>
    </section>
  );
};

export default InnovationNarration;
